import { combineReducers } from 'redux';
import bundlesReducer from './bundlesSlice';
import r2FilesReducer from './r2FilesSlice';

export default combineReducers({
  bundles: bundlesReducer,
  r2Files: r2FilesReducer
})
